import BlueSenturion from './assets/avatars/BlueSenturion.png'
import BMGold from './assets/avatars/BMGold.png'
import BMSilver from './assets/avatars/BMSilver.png'
import DCGold from './assets/avatars/DCGold.png'
import DCPurple from './assets/avatars/DCPurple.png'
import DCSilver from './assets/avatars/DCSilver.png'
import DFGold from './assets/avatars/DFGold.png'
import HFGreen from './assets/avatars/HFGreen.png'
import InSpaceSilver from './assets/avatars/InSpaceSilver.png'
import JFBatRanger from './assets/avatars/JFBatRanger.png'
import JFElephantRanger from './assets/avatars/JFElephantRanger.png'
import JFSharkRanger from './assets/avatars/JFSharkRanger.png'
import LunarWolf from './assets/avatars/LunarWolf.png'
import MagnaDefender from './assets/avatars/MagnaDefender.png'
import MercuryRanger from './assets/avatars/MercuryRanger.png'
import Ninjor from './assets/avatars/Ninjor.png'
import NSGreen from './assets/avatars/NSGreen.png'
import NSteelGold from './assets/avatars/NSteelGold.png'
import PhantomRanger from './assets/avatars/PhantomRanger.png'
import RoboKnight from './assets/avatars/RoboKnight.png'
import RPMGold from './assets/avatars/RPMGold.png'
import RPMSilver from './assets/avatars/RPMSilver.png'
import SamuaiGold from './assets/avatars/SamuaiGold.png'
import SMFSilver from './assets/avatars/SMFSilver.png'
import SolarisKnight from './assets/avatars/SolarisKnight.png'
import SolarRanger from './assets/avatars/SolarRanger.png'
import SPDNova from './assets/avatars/SPDNova.png'
import SPDOmega from './assets/avatars/SPDOmega.png'
import SPDShadow from './assets/avatars/SPDShadow.png'
import TitaniumRanger from './assets/avatars/TitaniumRanger.png'
import WolfWarrior from './assets/avatars/WolfWarrior.png'
import ZeoGold from './assets/avatars/ZeoGold.png'


import DC_Gold from './assets/CharacterCards/DC_GOLD.png'
import BM_GOLD from './assets/CharacterCards/BM_GOLD.png'
import BM_SILVER from './assets/CharacterCards/BM_SILVER.png'
import DC_PURPLE from './assets/CharacterCards/DC_PURPLE.png'
import DC_SILVER from './assets/CharacterCards/DC_SILVER.png'
import DF_GOLD from './assets/CharacterCards/DF_GOLD.png'
import HF_GREEN from './assets/CharacterCards/HF_GOLD.png'
import IS_SILVER from './assets/CharacterCards/IS_SILVER.png'
import JF_BAT from './assets/CharacterCards/JF_BAT.png'
import JF_ELEPHANT from './assets/CharacterCards/JF_ELEPHANT.png'
import JF_SHARK from './assets/CharacterCards/JF_SHARK.png'
import MAGNA_DEFENDER from './assets/CharacterCards/MAGNA_DEFENDER.png'
import MF_ROBOKNIGHT from './assets/CharacterCards/MF_ROBOKNIGHT.png'
import NINJOR from './assets/CharacterCards/NINJOR.png'
import NS_GREEN from './assets/CharacterCards/NS_GREEN.png'
import NST_GOLD from './assets/CharacterCards/NST_GOLD.png'
import OD_MERCURY from './assets/CharacterCards/OD_MERCURY.png'
import PHANTOM_RANGER from './assets/CharacterCards/PHANTOM_RANGER.png'
import RPM_GOLD from './assets/CharacterCards/RPM_GOLD.png'
import RPM_SILVER from './assets/CharacterCards/RPM_SILVER.png'
import SAMURAI_GOLD from './assets/CharacterCards/SAMURAI_GOLD.png'
import SMF_SILVER from './assets/CharacterCards/SMF_SILVER.png'
import SOLAR_PURPLE from './assets/CharacterCards/SOLAR_PURPLE.png'
import SOLARIS_KNIGHT from './assets/CharacterCards/SOLARIS_KNIGHT.png'
import SPD_NOVA from './assets/CharacterCards/SPD_NOVA.png'
import SPD_OMEGA from './assets/CharacterCards/SPD_OMEGA.png'
import SPD_SHADOW from './assets/CharacterCards/SPD_SHADOW.png'
import LSR_TITANIUM from './assets/CharacterCards/LSR_TITANIUM.png'
import Turbo_BlueSenturion from './assets/CharacterCards/Turbo_BlueSenturion.png'
import WF_LUNAR_WOLF from './assets/CharacterCards/WF_LUNAR_WOLF.png'
import WOLF_WARRIOR from './assets/CharacterCards/WOLF_WARRIOR.png'
import ZEO_GOLD from './assets/CharacterCards/ZEO_GOLD.png'


export const rangers = [
    {
        id:'dinoChargeGold',
        rangerName:'DINO CHARGE GOLD',
        realName:'',
        voteKey:'#DinoChargeGold',
        avatar:DCGold,
        characterCard: DC_Gold,
        ddLink:'https://www.dndbeyond.com/characters/95103487/ZYwtAi'
        

    },
    {
        id:'blueSenturion',
        rangerName:'BLUE SENTURION',
        realName:'Blue Senturion',
        voteKey:'#BlueSenturion',
        avatar:BlueSenturion,
        characterCard:Turbo_BlueSenturion,
        ddLink:'https://www.dndbeyond.com/characters/94953539/swSwtk'
    },
    {
        id:'superMegaForceSilver',
        rangerName:'SUPER MEGAFORCE SILVER',
        realName:'Orion',
        votingKey:'#SuperMegaforceSilver',
        avatar:SMFSilver,
        characterCard:SMF_SILVER,
        ddLink:'https://www.dndbeyond.com/characters/95101600/ISR4Nu'
    },
    {
        id:'roboKnight',
        rangerName:'ROBO KNIGHT',
        realName:'Robo Knight',
        votingKey:'#RoboKnight',
        avatar:RoboKnight,
        characterCard: MF_ROBOKNIGHT,
        ddLink:'https://www.dndbeyond.com/characters/95077836/0NK89j'
    },
    {
        id:'spdOmegaRanger',
        rangerName:'OMEGA RANGER',
        realName:'',
        votingKey:'#OmegaRanger',
        avatar:SPDOmega,
        characterCard:SPD_OMEGA,
        ddLink:'https://www.dndbeyond.com/characters/95000429/JEE4QE'
    },
    {
        id:'hyperForceGreen',
        rangerName:'HYPER FORCE GREEN',
        realName:'',
        votingKey:'#HyperForceGreen',
        avatar:HFGreen,
        characterCard:HF_GREEN,
        ddLink:'https://t.co/sVH1yvepar'
    },
    {
        id:'ninjor',
        rangerName:'NINJOR',
        realName:'Ninjor',
        votingKey:'#Ninjor',
        avatar:Ninjor,
        characterCard:NINJOR,
        ddLink:'https://www.dndbeyond.com/characters/94945850/YShiVL'
    },
    {
        id:'goldSamurai',
        rangerName:'GOLD SAMURAI',
        realName:'',
        votingKey:'#GoldSamurai',
        avatar:SamuaiGold,
        characterCard:SAMURAI_GOLD,
        ddLink:'https://www.dndbeyond.com/characters/95061887/5lyxXx'
    },
    {
        id:'operatorSeriesGold',
        rangerName:'OPERATOR SERIES GOLD',
        realName:'',
        votingKey:'#OperatorSeriesGold',
        avatar:RPMGold,
        characterCard:RPM_GOLD,
        ddLink:'https://www.dndbeyond.com/characters/95045615/vkEmU9'
    },
    {
        id:'dinoChargePurple',
        rangerName:'DINO CHARGE PURPLE',
        realName:'Kendal',
        votingKey:'#DinoChargePurple',
        avatar:DCPurple,
        characterCard:DC_PURPLE,
        ddLink:'https://www.dndbeyond.com/characters/95104117/V68bbv'
    },
    {
        id:'beastMorphersSilver',
        rangerName:'BEAST MORPHERS SILVER',
        realName:'Steel',
        votingKey:'#BeastMorphersSilver',
        avatar:BMSilver,
        characterCard: BM_SILVER,
        ddLink:'https://www.dndbeyond.com/characters/95108623/GMYaJl'
    },
    {
        id:'mercuryRanger',
        rangerName:'MERCURY RANGER',
        realName:'',
        votingKey:'#MercuryRanger',
        avatar:MercuryRanger,
        characterCard:OD_MERCURY,
        ddLink:'https://www.dndbeyond.com/characters/95037021/HBYpQp'
    },
    {
        id:'lunarWolfRanger',
        rangerName:'LUNAR WOLF RANGER',
        realName:'Merrick',
        votingKey:'#LunarWolfRanger',
        avatar:LunarWolf,
        characterCard: WF_LUNAR_WOLF,
        ddLink:'https://www.dndbeyond.com/characters/94982299/lPYqDf'
    },
    {
        id:'magnaDefender',
        rangerName:'MAGNA DEFENDER',
        realName:'',
        votingKey:'#MagnaDefender',
        avatar:MagnaDefender,
        characterCard:MAGNA_DEFENDER,
        ddLink:'https://www.dndbeyond.com/characters/94979612/YTatRY'
    },
    {
        id:'jungleFuryBatRanger',
        rangerName:'JUNGLE FURY BAT RANGER',
        realName:'',
        votingKey:'#JungleFuryBatRanger',
        avatar:JFBatRanger,
        characterCard:JF_BAT,
        ddLink:'https://www.dndbeyond.com/characters/95039549/0Hr4na'
    },
    {
        id:'dinoChargeSilver',
        rangerName:'DINO CHARGE SILVER',
        realName:'',
        voteKey:'#DinoChargeSilver',
        avatar:DCSilver,
        characterCard:DC_SILVER,
        ddLink:'https://www.dndbeyond.com/characters/95105323/YainzT'
    },
    {
        id:'goldZeo',
        rangerName:'Zeo Gold',
        realName:'Trey of Triforia',
        votingKey:'#ZeoGold',
        avatar:ZeoGold,
        characterCard: ZEO_GOLD,
        ddLink:'https://www.dndbeyond.com/characters/94948746/kfsxQH'
    },
    {
        id:'titaniumRanger',
        rangerName:'TITANIUM RANGER',
        realName:'Ryan Mitchell',
        votingKey:'#TitaniumRanger',
        avatar:TitaniumRanger,
        characterCard:LSR_TITANIUM,
        ddLink:'https://www.dndbeyond.com/characters/94980521/3cntTW'
    },
    {
        id:'solarisKnight',
        rangerName:'Solaris Knight',
        realName:'',
        votingKey:'#SolarisKnight',
        avatar:SolarisKnight,
        characterCard:SOLARIS_KNIGHT,
        ddLink:'https://www.dndbeyond.com/characters/95032851/qAy4Dj'
    },   
    {
        id:'spdShadowRanger',
        rangerName:'SPD SHADOW RANGER',
        realName:'Anubis Kreuger',
        votingKey:'#ShadowRanger',
        avatar:SPDShadow,
        characterCard:SPD_SHADOW,
        ddLink:'https://www.dndbeyond.com/characters/95003821/gm8f4S'
    },
    {
        id:'jungleFurySharkRanger',
        rangerName:'JUNGLE FURY SHARK RANGER',
        realName:'',
        votingKey:'#JungleFurySharkRanger',
        avatar:JFSharkRanger,
        characterCard:JF_SHARK,
        ddLink:'https://www.dndbeyond.com/characters/95042503/K7HLVR'
    },
    {
        id:'ninjaSteelGold',
        rangerName:'NINJA STEEL GOLD',
        realName:'',
        votingKey:'#NinjaSteelGold',
        avatar:NSteelGold,
        characterCard: NST_GOLD,
        ddLink:'https://www.dndbeyond.com/characters/95108029/l12jzw'
    },
    {
        id:'dinoFuryGold',
        rangerName:'DINO FURY GOLD',
        realName:'Ion',
        votingKey:'#DinoFuryGold',
        avatar:DFGold,
        characterCard: DF_GOLD,
        ddLink:'https://t.co/nYjazuQtq6'
    },
    {
        id:'operatorSeriesSilver',
        rangerName:'OPERATOR SERIES SILVER',
        realName:'',
        votingKey:'#OperatorSeriesSilver',
        avatar:RPMSilver,
        characterCard: RPM_SILVER,
        ddLink:'https://www.dndbeyond.com/characters/95046469/CerU7u'
    },
    {
        id:'ninjaStormGreen',
        rangerName:'NINJA STORM GREEN',
        realName:'Cam',
        votingKey:'#NinjaStormGreen',
        avatar:NSGreen,
        characterCard:NS_GREEN,
        ddLink:'https://www.dndbeyond.com/characters/94985279/AbNhA3'
    },
    {
        id:'inSpaceSilver',
        rangerName:'In Space Silver',
        realName:'Zhane',
        votingKey:'#InSpaceSilver',
        avatar:InSpaceSilver,
        characterCard:IS_SILVER,
        ddLink:'https://www.dndbeyond.com/characters/94947575/12Axjq'
    },
    {
        id:'jungleFuryElaphantRanger',
        rangerName:'JUNGLE FURY ELEPHANT RANGER',
        realName:'',
        votingKey:'#JungleFuryElephantRanger',
        avatar:JFElephantRanger,
        characterCard:JF_ELEPHANT,
        ddLink:'https://www.dndbeyond.com/characters/95041934/LTG731'
    },
    {
        id:'beastMorphersGold',
        rangerName:'BEAST MORPHERS GOLD',
        realName:'Nate',
        votingKey:'#BeastMorphersGold',
        avatar:BMGold,
        characterCard:BM_GOLD,
        ddLink:'https://www.dndbeyond.com/characters/95110295/1NwbOB'
    },
    {
        id:'wolfWarrior',
        rangerName:'WOLF WARRIOR',
        realName:'',
        votingKey:'#WolfWarrior',
        avatar:WolfWarrior,
        characterCard:WOLF_WARRIOR,
        ddLink:'https://www.dndbeyond.com/characters/95036136/0cbUhs'
    },
    {
        id:'phantomRanger',
        rangerName:'PHANTOM RANGER',
        realName:'Phantom Ranger',
        votingKey:'#PhantomRanger',
        avatar:PhantomRanger,
        characterCard: PHANTOM_RANGER,
        ddLink:'https://www.dndbeyond.com/characters/94977881/SxhDek'
    },
    {
        id:'spdNovaRanger',
        rangerName:'SPD NOVA RANGER',
        realName:'',
        votingKey:'#SPDNovaRanger',
        avatar:SPDNova,
        characterCard:SPD_NOVA,
        ddLink:'https://www.dndbeyond.com/characters/94988243/IJ2Gst'
    },
    {
        id:'solarRanger',
        rangerName:'SOLAR RANGER',
        realName:'',
        votingKey:'#SolarRanger',
        avatar:SolarRanger,
        characterCard: SOLAR_PURPLE,
        ddLink:'https://t.co/CCzluUltVI'
    }
    
    
    
]


export const roundOne = [
    {
        id:'matchOne',
        rangerTop: rangers[0],
        rangerBottom: rangers[1],
        // tweetId:'1631813248113598464',
        tweetId: '1632758012061405185',
        winning:[]
       
    },
    {
        id:'matchTwo',
        rangerTop: rangers[2],
        rangerBottom: rangers[3],
        tweetId:"1632773102043054080",
        winning:[]
    },
    {
        id:'matchThree',
        rangerTop: rangers[4],
        rangerBottom: rangers[5],
        tweetId:'1633120425898131459',
        winning:[]
    },
    {
        id:'matchFour',
        rangerTop: rangers[6],
        rangerBottom: rangers[7],
        tweetId:'1633135506396438529',
        winning:[]
    },
    {
        id:'matchFive',
        rangerTop: rangers[27],
        rangerBottom: rangers[9],
        tweetId:'1633482802858475523',
        winning:[]
    },
    {
        id:'matchSix',
        rangerTop: rangers[10],
        rangerBottom: rangers[11],
        tweetId:'1633497842345029633',
        winning:[]
    },
    {
        id:'matchSeven',
        rangerTop: rangers[12],
        rangerBottom: rangers[13],
        tweetId:'1633845141126656001',
        winning:[]
    },
    {
        id:'matchEight',
        rangerTop: rangers[14],
        rangerBottom: rangers[15],
        tweetId:'1633863514342457345',
        winning:[]
    },
    {
        id:'matchNine',
        rangerTop: rangers[16],
        rangerBottom: rangers[17],
        tweetId:"1632788343770554370",
        winning:[]
    },
    {
        id:'matchTen',
        rangerTop: rangers[18],
        rangerBottom: rangers[19],
        tweetId:'1632803367218020354',
        winning:[]
    },
    {
        id:'matchEleven',
        rangerTop: rangers[20],
        rangerBottom: rangers[21],
        tweetId:'1633150615168643094',
        winning:[]
    },
    {
        id:'matchTwelve',
        rangerTop: rangers[22],
        rangerBottom: rangers[23],
        tweetId:'1633165718324670499',
        winning:[]
    },
    {
        id:'matchThirteen',
        rangerTop: rangers[29],
        rangerBottom: rangers[25],
        tweetId:'1633512930451890189',
        winning:[]
    },
    {
        id:'matchFourteen',
        rangerTop: rangers[26],
        rangerBottom: rangers[8],
        tweetId:'1633528018701254658',
        winning:[]
    },
    {
        id:'matchFifteen',
        rangerTop: rangers[28],
        rangerBottom: rangers[24],
        tweetId:'1633875326995693569',
        winning:[]
    },
    {
        id:'matchSixteen',
        rangerTop: rangers[30],
        rangerBottom: rangers[31],
        tweetId:'1633891192386535432',
        winning:[]
    }
]




export const roundTwo = [
    {
        id:'matchOne',
        rangerTop: roundOne[0].rangerTop,
        rangerBottom: roundOne[1].rangerTop,
        // tweetId:'1631813248113598464',
        tweetId: '1635294683718115329',
        winning:[]
       
    },
    {
        id:'matchTwo',
        rangerTop: roundOne[2].rangerBottom,
        rangerBottom: roundOne[3].rangerTop,
        tweetId:'1635658248224227328',
        winning:[]
    },
    {
        id:'matchThree',
        rangerTop: roundOne[4].rangerBottom,
        rangerBottom: roundOne[5].rangerTop,
        tweetId:'1636021746129158144',
        winning:[]
    },
    {
        id:'matchFour',
        rangerTop: roundOne[6].rangerBottom,
        rangerBottom: roundOne[7].rangerTop,
        tweetId:'1636391523792343040',
        winning:[]
    },
    {
        id:'matchFive',
        rangerTop: roundOne[8].rangerTop,
        rangerBottom: roundOne[9].rangerBottom,
        tweetId:'1635309765080539138',
        winning:[]
    },
    {
        id:'matchSix',
        rangerTop: roundOne[10].rangerTop,
        rangerBottom: roundOne[11].rangerBottom,
        tweetId:'1635672533289639937',
        winning:[]
    },
    {
        id:'matchSeven',
        rangerTop: roundOne[12].rangerBottom,
        rangerBottom: roundOne[13].rangerBottom,
        tweetId:'1636050274405040151',
        winning:[]
    },
    {
        id:'matchEight',
        rangerTop: roundOne[14].rangerBottom,
        rangerBottom: roundOne[15].rangerBottom,
        tweetId:'1636398586060521473',
        winning:[]
    }
]

export const roundThree = [
    {
        id:'matchOne',
        rangerTop: roundTwo[0].rangerTop,
        rangerBottom: roundTwo[1].rangerTop,
        tweetId:'1637846644141047810',
        winning:[]
       
    },
    {
        id:'matchTwo',
        rangerTop: roundTwo[2].rangerTop,
        rangerBottom: roundTwo[3].rangerTop,
        tweetId:'1638558707117064194',
        winning:[]
    },
    {
        id:'matchThree',
        rangerTop: roundTwo[4].rangerBottom,
        rangerBottom: roundTwo[5].rangerBottom,
        tweetId:'1638193910223626244',
        winning:[]
    },
    {
        id:'matchFour',
        rangerTop: roundTwo[6].rangerTop,
        rangerBottom: roundTwo[7].rangerTop,
        tweetId:'1638927417518505987',
        winning:[]
    }
]


export const semi = [
    {
            id:'matchOne',
            rangerTop: roundThree[0].rangerTop,
            rangerBottom: roundThree[1].rangerBottom,
            tweetId:'1640353091768705025',
            winning:[]
    },
    {
        id:'matchOne',
        rangerTop: roundThree[2].rangerTop,
        rangerBottom: roundThree[3].rangerBottom,
        tweetId:'1640726126690435073',
        winning:[]
},

]

export const finals = [{
    id:'matchOne',
    rangerTop: semi[0].rangerBottom,
    rangerBottom: semi[1].rangerTop,
    tweetId:'1641440398974521346',
    winning:[]
}]
